import React, { useContext, useState } from "react";
import { AuthContext } from "@app/providers";
import Header from "../header";
import { useLocation } from "react-router-dom";

export default function CommonLayout() {
  const { userInfo }: any = useContext(AuthContext);
  const userToken: any = userInfo && userInfo.sessionToken;
  const location = useLocation();
  const pathData = location.pathname.split('/');
  var displayHeader = true;

  if (pathData[1] == "wfname") {
    displayHeader = false;
  }
  if (userToken && displayHeader) {
    return <Header />;
  } else {
    return null;
  }
}
